import React from "react";
import { connect } from "react-redux";
import { getPartNumberColorClassNameByTierType } from "MODULES/shared/helpers";
import { Link } from "react-router-dom";
import T from "prop-types";
import { markRead } from "MODULES/Notifications/actions";

const PartLink = ({
  markNotificationRead,
  notificationId,
  partId,
  partNumber,
  part,
  tierType,
  uuid
}) => {
  const classes = getPartNumberColorClassNameByTierType(
    (part && part.tier_type) || tierType
  );

  const id = uuid || (part && part.uuid) || partId || (part && part.id);
  const numb = partNumber || (part && part.part_number);

  if (!id) return <span className={classes}>PN-{numb}</span>;

  return (
    <span
      onClick={e => {
        e.stopPropagation();
        markNotificationRead && markNotificationRead(notificationId);
      }}
    >
      <Link to={`/parts/${id}`}>
        <span className={classes || "text-orange"}>PN-{numb}</span>
      </Link>
    </span>
  );
};

export default connect(undefined, dispatch => ({
  markNotificationRead: noteId => dispatch(markRead(noteId))
}))(PartLink);

PartLink.propTypes = {
  markNotificationRead: T.func,
  notificationId: T.number,
  part: T.shape({}),
  partId: T.string,
  partNumber: T.string,
  tierType: T.string,
  uuid: T.string
};



// WEBPACK FOOTER //
// ./app/modules/Notifications/components/Search/PartLink.jsx